import { h } from 'preact';
import { ChannelBadge } from '../ChannelBadge';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'ChannelBadge',
  category: '🏷️ Badges & Indicadores',
  description: 'Badge de canal com ícone SVG (Telegram, WhatsApp, Discord)',
  usedIn: ['AgentesPage'],
  example: () => (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      <ChannelBadge name="Telegram" />
      <ChannelBadge name="WhatsApp" />
      <ChannelBadge name="Discord" />
    </div>
  ),
};
